export default {
  loading: 'Loading consumption...',
  errorTitle: 'Consumption Not Found',
  notFound: 'The requested consumption could not be found',
  fetchError: 'Failed to load consumption',
  consumptionDetails: 'Consumption Details',
  unitsConsumed: 'units consumed',
  resource: 'Resource',
  consumer: 'Consumer',
  quantityConsumed: 'Quantity Consumed',
  consumedAt: 'Consumed At',
  notes: 'Notes'
};
